import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  dark?: boolean;
}

export default function Breadcrumb({ items, dark = false }: BreadcrumbProps) {
  const { t } = useTranslation();

  const textColor = dark ? 'text-background-300/70' : 'text-foreground-500';
  const textColorActive = dark ? 'text-background-50' : 'text-foreground-800';
  const hoverColor = dark ? 'hover:text-primary-400' : 'hover:text-primary-600';
  const arrowColor = dark ? 'text-background-500' : 'text-foreground-400';

  return (
    <nav aria-label="面包屑导航" className={`flex items-center gap-1.5 text-sm flex-wrap ${textColor}`}>
      <Link
        to="/"
        className={`${hoverColor} transition-colors whitespace-nowrap`}
      >
        {t('article.breadcrumb.home')}
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={`ri-arrow-right-s-line text-xs ${arrowColor}`}></i>
          </span>
          {item.path ? (
            <Link
              to={item.path}
              className={`${hoverColor} transition-colors whitespace-nowrap`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={`${textColorActive} font-medium`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}